import { withChartLayout } from 'components/common';
import PatientCard from 'components/features/chart/patient-card/PatientCard';

const PatientCardPage = withChartLayout('Patient Card')(PatientCard);
export default PatientCardPage;
